import { FormElement, ElementData } from "./Element";
import { MasonControls } from "lib/mason";
import { PatchConfig } from "data/form/types";

// Form status
export type FormStatusTypes =
	| "LOADING"
	| "UPDATING"
	| "READY"
	| "ERROR"
	| "CLOSED";

export const formStatus = {
	loading: "LOADING",
	ready: "READY",
	updating: "UPDATING",
	error: "ERROR",
	closed: "CLOSED",
} as const;

export interface UiProps {
	init: boolean;
	status: FormStatusTypes;
	ready: boolean;
	updateQueue: ReadonlyArray<string>;
	updating: ReadonlyArray<string>;
	messages: string[];
	patches: PatchConfig[];
	message?: string;
}

const uiDefaults: UiProps = {
	init: false,
	status: formStatus.loading,
	ready: false,
	updateQueue: [],
	updating: [],
	messages: [],
	patches: [],
};

export interface FormData {
	[k: string]: { [k: string]: ElementData }[];
}

export interface FormConfig {
	controls: MasonControls;
	dirty: boolean;
	data: FormData;
	elements: Readonly<{ [k: string]: Readonly<FormElement> }>;
	instanceId: string;
	rootElement: string;
	formLabel: string;
	readOnly: boolean;
	bindings: { [k: string]: string | null };
	formLayout: {
		fullWidth: boolean;
		maxWidth: number | null;
	};
}

export interface Form {
	_ui: UiProps;
	server: FormConfig;
}

export function createForm(
	config: FormConfig,
	uiConf?: UiProps
): Readonly<Form> {
	return {
		_ui: Object.assign({}, uiDefaults, uiConf),
		server: {
			...config,
		},
	};
}
